import styled from "styled-components";
import {Col, Row, Select, Button, Input} from "antd";

export const MergeOptionsWrapper = styled.div`
    @media (max-width: 768px) {
        padding: 0 8px;

        h2 {
            font-size: 18px;
            margin-bottom: 8px;
        }
    }
`;

export const CompanyContanier = styled.div`
    padding: 5px 20px 5px 20px;
    border: 1.5px solid #d9d9d9;
    border-radius: 2px;

    .ant-form-item {
        margin-top: 10px;
    }
    .ant-table-cell {
        padding: 5px 15px 5px 15px;
    }

    @media (max-width: 768px) {
        padding: 5px 8px;
    }
`;

/* Masaüstünde tablo görünsün, mobilde gizlensin */
export const MergeOptionsTableWrap = styled.div`
    @media (max-width: 768px) {
        display: none !important;
    }
`;

/* Mobilde liste görünsün: her satır = etiket + kontrol (alt alta) */
export const MergeOptionsList = styled.div`
    display: none;

    @media (max-width: 768px) {
        display: block;
    }
`;

export const MergeOptionsListRow = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 10px 0;
    border-bottom: 1px solid #f0f0f0;
    gap: 6px;

    &:first-of-type {
        padding-top: 0;
    }

    .merge-options-label {
        font-size: 12px;
        font-weight: 600;
        color: rgba(0, 0, 0, 0.85);
    }

    .ant-form-item {
        margin-bottom: 0;
        width: auto;
    }

    .ant-form-item-control-input-content {
        display: inline-block;
    }

    .ant-input {
        font-size: 12px;
        width: 100%;
    }

    .ant-switch {
        min-width: 50px;
        width: auto !important;
    }
`;

export const TableContainer = styled.div`
    padding: 5px 5px 5px 5px;
    border: 1.5px solid #d9d9d9;

    border-radius: 2px;

    .ant-form-item {
        margin-top: 10px;
    }
    .ant-table-cell {
        padding: 5px 10px 5px 10px;
    }
    margin-top: 10px;

    @media (max-width: 768px) {
        padding: 4px;

        .ant-table-cell {
            padding: 4px 6px;
            font-size: 12px;
        }
    }
`;

export const FilterContainer = styled(Row)`
    margin-top: 20px;
    margin-bottom: 20px;

    @media (max-width: 768px) {
        margin-top: 12px;
        margin-bottom: 12px;
    }
`;

export const FilterWrapper = styled.div`
    @media (max-width: 768px) {
        width: 100%;

        > .ant-col {
            flex: 0 0 100% !important;
            max-width: 100% !important;
            width: 100% !important;
        }

        .ant-row {
            row-gap: 12px !important;
            flex-wrap: wrap !important;
        }

        .ant-row > .ant-col {
            flex: 0 0 50% !important;
            max-width: 50% !important;
            width: 50% !important;
        }
    }
`;

export const SelectField = styled(Select)`
    width: 100%;
`;

export const SubCompanyContainer = styled.div`
    padding: 20px;
    border: 1.5px solid #d9d9d9;
    border-radius: 2px;

    @media (max-width: 768px) {
        padding: 8px;
        overflow-x: auto;
        -webkit-overflow-scrolling: touch;

        .ant-table-cell {
            padding: 6px 8px;
            font-size: 12px;
            min-width: 60px;
        }

        .ant-table {
            font-size: 12px;
        }

        .ant-input {
            min-width: 50px;
            font-size: 12px;
        }

        .ant-pagination {
            justify-content: center;
        }
    }
`;

/* Alt firma tablosu: masaüstünde tablo, mobilde gizle */
export const SubCompanyTableWrap = styled.div`
    @media (max-width: 768px) {
        display: none !important;
    }
`;

/* Mobilde alt firma kart listesi */
export const SubCompanyCardList = styled.div`
    display: none;

    @media (max-width: 768px) {
        display: block;
    }
`;

export const SubCompanyCard = styled.div`
    padding: 12px;
    margin-bottom: 12px;
    border: 1px solid #f0f0f0;
    border-radius: 4px;
    background: #fafafa;

    &:last-of-type {
        margin-bottom: 0;
    }
`;

export const SubCompanyCardTitle = styled.div`
    font-weight: 600;
    font-size: 14px;
    margin-bottom: 10px;
    padding-bottom: 8px;
    border-bottom: 1px solid #e8e8e8;
`;

export const SubCompanyCardRow = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
    padding: 8px 0;
    border-bottom: 1px solid #f0f0f0;
    font-size: 12px;

    &:last-of-type {
        border-bottom: none;
    }

    .subcompany-card-label {
        font-weight: 500;
        color: rgba(0, 0, 0, 0.65);
    }

    .ant-form-item {
        margin-bottom: 0;
        width: auto;
    }

    .ant-form-item-control-input-content {
        display: inline-block;
    }

    .ant-input {
        font-size: 12px;
        width: 100%;
        max-width: 120px;
    }

    .ant-switch {
        width: auto !important;
    }
`;

export const SubCompanyCardActions = styled.div`
    margin-top: 12px;
    padding-top: 8px;
    border-top: 1px solid #e8e8e8;
`;

export const CompanyButtonContainer = styled(Row)`
    padding: 16px;

    @media (max-width: 768px) {
        padding: 10px 8px;
        flex-direction: column;
        align-items: flex-start;
        gap: 10px;

        .ant-checkbox-wrapper {
            margin-bottom: 4px;
        }

        .ant-btn {
            width: 100%;
        }
    }
`;

export const RadioContainer = styled.div`
    margin-top: 10px;
    margin-bottom: 10px;

    @media (max-width: 768px) {
        margin-top: 8px;
        margin-bottom: 8px;

        .ant-radio-group {
            display: flex;
            flex-direction: column;
            gap: 6px;
        }
    }
`;

export const DeliveryType = styled.div`
    margin: 0 10px;
`;

export const DeliveryTypeItem = styled(Col)`
    margin: 0 10px;
`;

export const DeliveryTypeLabel = styled.h6`
    font-size: 12px;
`;

export const DeliveryTypeWarning = styled.span`
    color: red;
    font-size: 12px;
    margin-left: 10px;
`;

export const SlotDeleteButton = styled(Button)`
    display: flex;
    margin-bottom: 15px;
`;

export const IconCol = styled(Col)`
    margin: auto 0;
    color: #ffffff;
    font-size: 20px;
    background: #009688;
    border-radius: 50%;
    padding: 5px;
    margin-right: 10px;
`;

export const SlotCourierSelectField = styled(Select)`
    .ant-select-selection-item {
        height: auto !important;
    }
`;
